import { ids } from '@icarros/theme-react';
import styled, { css } from 'styled-components';

interface ListItemModifierProps {
  isHighlight?: boolean;
}

export const MetricsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  gap: 28px;

  > div:first-of-type {
    max-width: 486px;
  }

  @media (min-width: 1366px) {
    min-height: 100vh;
    padding-block-start: 24px !important;
    flex: 1;

    border-right: 1px solid ${ids.color.border.ids_color_border_soft};
    padding-inline-end: 72px !important;
  }
`;

export const MetricsHeader = styled.div`
  button {
    flex-direction: row-reverse;
    padding-left: 0;
    margin-block-end: 52px;
  }
  > div:first-of-type {
    margin-bottom: 4px;
  }
`;

export const MenuButtonModifier = styled.div`
  margin-bottom: 4px;
  > button {
    padding: 24px 24px 44px 24px;

    svg path {
      fill: ${ids.color.action.secondary.ids_color_action_secondary_base} !important;
    }
  }
`;

export const TitleModifier = styled.div`
  margin-top: 16px;
  margin-bottom: 4px;
`;

export const ListItemModifier = styled.div<ListItemModifierProps>`
  > div {
    width: 100%;
  }

  > div > div:first-of-type {
    padding-left: 0;
    svg {
      width: 24px;
      height: 24px;
    }
  }

  > div > div:nth-of-type(2) {
    margin-left: 0;
  }

  &:last-of-type {
    > div:empty {
      display: none;
    }
  }

  ${({ isHighlight }) =>
    isHighlight &&
    css`
      &:first-of-type {
        margin-top: 60px;
      }
      > div {
        margin-block: 14px;
      }

      svg {
        fill: ${ids.color.action.secondary.ids_color_action_secondary_base};
      }
    `}
`;
